import { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { getCurrentPhase, getTrackingMode } from '../utils/cycleCalculator'

export const useUserData = () => {
  const { user } = useAuth()
  const [userProfile, setUserProfile] = useState(null)
  const [currentPhase, setCurrentPhase] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (user) {
      // For authenticated users, use their metadata and localStorage
      const profile = {
        user_id: user.id,
        full_name: user.user_metadata?.full_name || '',
        tracking_mode: user.user_metadata?.tracking_mode || localStorage.getItem('trackingMode') || 'cycle',
        last_period_date: localStorage.getItem('lastPeriodDate'),
        cycle_length: parseInt(localStorage.getItem('cycleLength')) || 28
      }
      
      setUserProfile(profile)
      
      // Calculate current phase
      const phase = getCurrentPhase()
      setCurrentPhase(phase)
    } else {
      // Use local storage fallback for non-authenticated users
      const trackingMode = getTrackingMode()
      if (trackingMode) {
        const phase = getCurrentPhase()
        setCurrentPhase(phase)
      }
    }
    
    setLoading(false)
  }, [user])

  const updateUserProfile = async (updates) => {
    if (!user) return { error: 'Not authenticated' }
    
    try {
      // Update localStorage
      Object.keys(updates).forEach(key => {
        if (updates[key] !== null && updates[key] !== undefined) {
          localStorage.setItem(key, updates[key].toString())
        }
      })
      
      // Update local state
      setUserProfile(prev => ({ ...prev, ...updates }))
      
      // Recalculate phase
      const phase = getCurrentPhase()
      setCurrentPhase(phase)
      
      return { data: updates, error: null }
    } catch (error) {
      return { error: error.message }
    }
  }

  return {
    user,
    userProfile,
    currentPhase,
    loading,
    updateUserProfile,
    refreshProfile: () => {
      const phase = getCurrentPhase()
      setCurrentPhase(phase)
    }
  }
}